import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import { t } from "i18next";
import { TextInput } from "pepsico-ds";
import { useContext } from "react";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import DatePickerMaterialUIField from "../datePickerMaterialUI/DatePickerMaterialUIField";

function TCConsentList({ data, visible }) {
  const ctx = useJsonForms();
  const globalConfig = useContext(GlobalConfigContext);
  const currentProgramTimezone =
    globalConfig?.globalState?.programConfig?.localization?.programTimezone;

  if (!visible) {
    return null;
  }

  const rootData = ctx?.core?.data;
  const resolvedData = data ?? rootData?.consent;

  const tcConsents = Array.isArray(resolvedData)
    ? resolvedData.find((c) => c?.type === "terms_and_conditions")?.consents
    : resolvedData;

  const rows = Array.isArray(tcConsents) ? tcConsents : [];

  return (
    <div>
      {rows.map((item, index) => {
        const safeItem = item && typeof item === "object" ? item : {};
        const name = safeItem.type ?? safeItem.name ?? "";
        const version = safeItem.version_number ?? safeItem.version ?? "";
        const acceptedAt =
          safeItem.date_accepted ??
          safeItem.acceptance_date ??
          safeItem.accepted_at ??
          "";

        return (
          <div
            key={index}
            style={{ display: "flex", gap: "12px", marginBottom: "12px" }}
          >
            <div style={{ flex: 1 }}>
              <TextInput
                className="font-sm"
                value={String(name ?? "")}
                disabled={true}
                label={t("CustomerSupport:TermsAndConditionsAgreementNameLabel")}
              />
            </div>
            <div style={{ flex: 1 }}>
              <DatePickerMaterialUIField
                value={acceptedAt || null}
                label={t("CustomerSupport:LastTCAcceptedDateLabel")}
                updateValue={() => null}
                uiSchema={{}}
                visible={true}
                disabled={true}
                readOnly={true}
                timezone={currentProgramTimezone}
              />
            </div>
            <div style={{ flex: 1 }}>
              <TextInput
                className="font-sm"
                value={String(version ?? "")}
                disabled={true}
                label={t("CustomerSupport:VersionNumberLabel")}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export const TCConsentListControl = withJsonFormsControlProps(TCConsentList);
